/**
 * Convert a zero-based citation-group index into its display letter using a
 * base-26 sequence (A..Z, AA, AB, …) so labels keep incrementing past 26
 * groups. Shared by the walkthrough panel and the Add Citation group picker so
 * the dropdown letters mirror the panel headings exactly.
 */
export function getGroupLetter(index: number): string {
  let result = "";
  let n = index;
  do {
    result = String.fromCharCode(65 + (n % 26)) + result;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);
  return result;
}
